import { createApp } from '@backstage/frontend-defaults';
import catalogPlugin from '@backstage/plugin-catalog/alpha';
import gitlabPlugin from '@immobiliarelabs/backstage-plugin-gitlab/alpha';
import gitlabSpaceRepoPickerModule from '@internal/backstage-plugin-scaffolder-frontend-module-gitlab-space-picker';
import { navModule } from './modules/nav';
import { themeModule } from './modules/theme/index';
import { authModule } from './modules/auth';
import { homePlugin } from './modules/home';
import { spaceManagerPlugin } from './modules/space-manager';
import { resourceDetailsModule } from './modules/catalog/resourceDetails';
import { gitlabCardFiltersModule } from './modules/gitlab';
import { settingsModule } from './modules/settings';

export default createApp({
  features: [
    catalogPlugin,
    gitlabPlugin,
    navModule,
    themeModule,
    authModule,
    homePlugin,
    spaceManagerPlugin,
    resourceDetailsModule,
    gitlabCardFiltersModule,
    gitlabSpaceRepoPickerModule,
    settingsModule,
  ],
});
